import { eventMonitor } from "@/api/eventMonitor";
import { dispatchCheckApiError } from "@/store/main/actions";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "@/store/state";
import { ActionContext } from "vuex";
import { commitAddNotification } from "@/store/main/mutations";
import {
  ModelParameter,
  ModelParameterUpdate,
} from "@/interfaces/modelparameter";

export interface ModelParameterState {
  modelParameters: ModelParameter[];
}

const defaultState: ModelParameterState = {
  modelParameters: [],
};

// Getters
const getters = {
  modelParameters: (state: ModelParameterState): ModelParameter[] => {
    return state.modelParameters;
  },
};

const { read } = getStoreAccessors<ModelParameterState, State>("");

export const readModelParameters = read(getters.modelParameters);

// Mutations

const mutations = {
  setModelParameters(
    state: ModelParameterState,
    modelParameters: ModelParameter[]
  ): void {
    state.modelParameters = modelParameters;
  },
  setModelParameter(
    state: ModelParameterState,
    modelparameter: ModelParameter
  ): void {
    const parameters = state.modelParameters.filter(
      (a: ModelParameter) => a.id !== modelparameter.id
    );
    parameters.push(modelparameter);
    state.modelParameters = parameters;
  },
};

const { commit } = getStoreAccessors<ModelParameterState, State>("");

export const commitSetModelParameters = commit(mutations.setModelParameters);
export const commitSetModelParameter = commit(mutations.setModelParameter);

// Actions

type MainContext = ActionContext<ModelParameterState, State>;

const actions = {
  async actionGetModelParameters(context: MainContext): Promise<void> {
    try {
      const response = await eventMonitor.getModelParameters(
        context.rootState.main.token
      );
      commitSetModelParameters(context, response.data);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },

  async actionUpdateModelParameter(
    context: MainContext,
    payload: ModelParameterUpdate
  ): Promise<void> {
    try {
      const response = await eventMonitor.updateModelParameters(
        context.rootState.main.token,
        payload
      );
      commitSetModelParameter(context, response.data);
    } catch (error) {
      await dispatchCheckApiError(context, error);
    }
  },
};

const { dispatch } = getStoreAccessors<ModelParameterState, State>("");

export const dispatchActionGetModelParameters = dispatch(
  actions.actionGetModelParameters
);
export const dispatchActionUpdateModelParameter = dispatch(
  actions.actionUpdateModelParameter
);

// Module

export const modelParametersModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
